/**
 * Match a seed day string to a calendar date.
 * Plain weekdays and "Daily" match that day.
 * First / second / third / last-of-month lines match only that occurrence.
 * Alternating weeks are skipped: the seed does not say which weeks.
 */
var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function mentionsWeekday(text, index) {
  var name = WEEKDAYS[index];
  var re = new RegExp('\\b' + name + 's?\\b', 'i');
  return re.test(text);
}

function occurrenceIndex(date) {
  return Math.floor((date.getDate() - 1) / 7) + 1;
}

function isLastWeekdayOfMonth(date) {
  var next = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7);
  return next.getMonth() !== date.getMonth();
}

function ordinalWanted(text) {
  var lower = String(text || '').toLowerCase();
  if (/\blast\b/.test(lower)) return 'last';
  if (/\b(1st|first)\b/.test(lower)) return 1;
  if (/\b(2nd|second)\b/.test(lower)) return 2;
  if (/\b(3rd|third)\b/.test(lower)) return 3;
  if (/\b(4th|fourth)\b/.test(lower)) return 4;
  if (/\b5th\b/.test(lower)) return 5;
  return null;
}

function isQualified(text) {
  return /(\d+(?:st|nd|rd|th)|first|second|third|fourth|last|alternating|each month|of the month|of month)/i.test(text);
}

function eventRunsOn(dayStr, date) {
  var s = String(dayStr || '').trim();
  if (!s || !date) return false;
  var lower = s.toLowerCase();
  if (lower === 'daily' || lower.indexOf('daily') === 0) return true;
  var idx = date.getDay();
  if (!mentionsWeekday(s, idx)) return false;
  if (/\balternating\b/i.test(s)) return false;
  if (!isQualified(s)) return true;
  var want = ordinalWanted(s);
  if (want === 'last') return isLastWeekdayOfMonth(date);
  if (typeof want === 'number') return occurrenceIndex(date) === want;
  return false;
}

function dateForWeekday(index, from) {
  var base = from || new Date();
  var local = new Date(base.getFullYear(), base.getMonth(), base.getDate());
  var delta = (index - local.getDay() + 7) % 7;
  local.setDate(local.getDate() + delta);
  return local;
}

function isPlainWeekdayLabel(dayStr) {
  var lower = String(dayStr || '').trim().toLowerCase();
  var i;
  for (i = 0; i < WEEKDAYS.length; i++) {
    var name = WEEKDAYS[i].toLowerCase();
    if (lower === name || lower === name + 's') return true;
  }
  return false;
}

module.exports = {
  WEEKDAYS: WEEKDAYS,
  eventRunsOn: eventRunsOn,
  isQualified: isQualified,
  dateForWeekday: dateForWeekday,
  isPlainWeekdayLabel: isPlainWeekdayLabel
};

if (require.main === module) {
  var sun = new Date(2026, 9, 4);
  var sat = new Date(2026, 9, 10);
  var sun2 = new Date(2026, 9, 11);
  function assert(cond, msg) {
    if (!cond) throw new Error(msg);
  }
  assert(sun.getDay() === 0, 'oct 4 2026 is sunday');
  assert(eventRunsOn('Sundays', sun), 'sundays');
  assert(!eventRunsOn('Mondays', sun), 'not monday');
  assert(eventRunsOn('Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays', sun), 'all week');
  assert(eventRunsOn('Daily', sun), 'daily');
  assert(eventRunsOn('Daily (see notes)', sun), 'daily notes');
  assert(!eventRunsOn('Sundays (alternating)', sun), 'alternating skipped');
  assert(eventRunsOn('Sundays (first of month)', sun), 'first sunday oct 4');
  assert(!eventRunsOn('Sundays (first of month)', sun2), 'second sunday is not first');
  assert(eventRunsOn('Sunday', sun), 'singular sunday');
  assert(eventRunsOn('Tuesday, Wednesday, Thursday, Saturday, Sunday', sun), 'list singular');
  assert(!eventRunsOn('3rd Saturday of the month', sat), 'oct 10 is 2nd saturday');
  assert(eventRunsOn('2nd Saturdays', sat), '2nd saturday');
  assert(!eventRunsOn('1st Saturdays', sat), 'not 1st saturday');
  assert(eventRunsOn('Friday', new Date(2026, 9, 2)), 'singular friday');
  assert(dateForWeekday(6, sun).getDate() === 10, 'next saturday from oct 4');
  assert(dateForWeekday(0, sun).getDate() === 4, 'sunday stays today');
  console.log('day-match ok');
}



// WEBPACK FOOTER //
// ./js/day-match.js